import ClassService from '@/services/class.service';
import axios from "axios";

export const classModule = {
    namespaced: true,
    state: {
        requests: [],
        class: {},
        classes: new Map(),
        rooms: new Map(),
        license: {},
        licenses: new Map(),
    },
    actions: {
        clearRequest({state}, name) {
            state.requests = state.requests.filter(obj => obj.requestName !== name);
        },
        makeOrCancelRequest({state}, name) {
            const requestExist = state.requests.find((item) => {
                return item.requestName === name ? item : null
            })

            if (requestExist)
                requestExist.cancel()

            const axiosSource = axios.CancelToken.source();

            state.requests = state.requests.filter(obj => obj.requestName !== name);
            state.requests.push({requestName: name, cancel: axiosSource.cancel});

            return axiosSource;
        },
        async createClass({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "createClass");
            return ClassService.createClass(axiosSource, data).then(
                async data => {
                    commit('insertClass', data)
                    await dispatch('clearRequest', "createClass");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async updateClass({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "updateClass");
            return ClassService.updateClass(axiosSource, data).then(
                async data => {
                    commit('updateClassData', data)
                    await dispatch('clearRequest', "updateClass");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async deleteClass({commit, dispatch}, classId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "deleteClass");
            return ClassService.deleteClass(axiosSource, classId).then(
                async data => {
                    commit('removeClassFromList', classId)
                    await dispatch('clearRequest', "deleteClass");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async getClass({commit, dispatch}, classId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "getClass");
            return ClassService.getClass(axiosSource, classId).then(
                async data => {
                    commit('updateActiveClass', data)
                    await dispatch('clearRequest', "getClass");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listClassesByCourseId({commit, dispatch}, course_id) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listClassesByCourseId");
            return ClassService.listClassesByCourseId(axiosSource, course_id).then(
                async data => {
                    commit('updateClassesList', data)
                    await dispatch('clearRequest', "listClassesByCourseId");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listClasses({commit, dispatch}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listClasses");
            return ClassService.listClasses(axiosSource).then(
                async data => {
                    commit('updateClassesList', data);
                    await dispatch('clearRequest', "listClasses");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async syncClassStudents({commit, dispatch}, {classId, data}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "syncClassStudents");
            return ClassService.syncClassStudents(axiosSource, classId, data).then(
                async data => {
                    commit('updateActiveClass', data);
                    await dispatch('clearRequest', "syncClassStudents");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listRooms({commit, dispatch}, classId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listRooms");
            return ClassService.listRooms(axiosSource, classId).then(
                async data => {
                    commit('updateRoomsList', data);
                    await dispatch('clearRequest', "listRooms");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async createLicense({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "createLicense");
            return ClassService.createLicense(axiosSource, data).then(
                async data => {
                    commit('insertLicense', data)
                    await dispatch('clearRequest', "createLicense");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async updateLicense({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "updateLicense");
            return ClassService.updateLicense(axiosSource, data).then(
                async data => {
                    commit('updateLicenseData', data)
                    await dispatch('clearRequest', "updateLicense");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async deleteLicense({commit, dispatch}, licenseId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "deleteLicense");
            return ClassService.deleteLicense(axiosSource, licenseId).then(
                async data => {
                    commit('removeLicenseFromList', licenseId)
                    await dispatch('clearRequest', "deleteLicense");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listLicenses({commit, dispatch}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listLicenses");
            return ClassService.listLicenses(axiosSource).then(
                async data => {
                    commit('updateLicensesList', data);
                    await dispatch('clearRequest', "listLicenses");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async getLicense({commit, dispatch}, licenseId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "getLicense");
            return ClassService.getLicense(axiosSource, licenseId).then(
                async data => {
                    commit('updateActiveLicense', data);
                    await dispatch('clearRequest', "getLicense");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async myLicense({commit, dispatch}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "myLicense");
            return ClassService.myLicense(axiosSource).then(
                async data => {
                    commit('updateActiveLicense', data);
                    await dispatch('clearRequest', "myLicense");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
    },
    mutations: {
        updateClassesList(state, data) {
            state.classes = new Map()
            for (const entity of data) {
                state.classes.set(entity.id, entity)
            }
        },
        insertClass(state, data) {
            state.classes.set(data.id, data)
        },
        updateClassData(state, data) {
            state.classes.set(data.id, data)
        },
        removeClassFromList(state, classId) {
            state.classes.delete(classId)
        },
        updateActiveClass(state, data) {
            state.class = data;
        },
        updateRoomsList(state, data) {
            state.rooms = new Map()
            for (const entity of data) {
                state.rooms.set(entity.id, entity)
            }
        },
        updateLicensesList(state, data) {
            state.licenses = new Map()
            for (const entity of data) {
                state.licenses.set(entity.id, entity)
            }
        },
        insertLicense(state, data) {
            state.licenses.set(data.id, data)
        },
        updateLicenseData(state, data) {
            state.licenses.set(data.id, data)
        },
        removeLicenseFromList(state, licenseId) {
            state.licenses.delete(licenseId)
        },
        updateActiveLicense(state, data) {
            state.license = data;
        },
    }
};